<template lang="pug">
  div(v-if="contentVisible")
    // Correct Answer, Score
    el-row(:gutter="20" style="margin: 2%;")
      el-collapse(accordion=true)
        div(
          style="flex-grow: 1;"
          v-for="testCase, testIndex in questionData.testCases"
          :key="testIndex"
        )
          el-collapse-item
            div(slot="title")
              i(class="el-icon-notebook-2 testLabel" style="font-size: 1.25em")
              span(class="testLabel") Test Case {{ testIndex + 1 }}
            el-col(:span="1") &nbsp;
            el-col(:span="20")
              el-row.margin-top-5(v-if="testCase.initVar.isActive")
                el-col(:span="6")
                  span(class="fieldLabel") Initial Variables
                el-col(:span="18")
                  span(v-for="vars in testCase.initVar.vars")
                    span(class="fieldValue") {{ `${vars.name} = ${vars.value}` }}
              
              el-row.margin-top-5(v-if="testCase.varName.isActive")
                el-col(:span="6")
                  span(class="fieldLabel") Variable Names
                el-col(:span="18")
                  span(v-for="vars in testCase.varName.vars")
                    custom-point-badge(:value="vars.score")
                      span(class="fieldValue") {{ `${vars.name}` }}
              
              el-row.margin-top-5(v-if="testCase.varType.isActive")
                el-col(:span="6")
                  span(class="fieldLabel") Variable Types
                el-col(:span="18")
                  span(v-for="vars in testCase.varType.vars")
                    custom-point-badge(:value="vars.score")
                      span(class="fieldValue") {{ `${vars.name} is ${vars.value}` }}
              
              el-row.margin-top-5(v-if="testCase.varValue.isActive")
                el-col(:span="6")
                  span(class="fieldLabel") Variable Equations
                el-col(:span="18")
                  span(v-for="vars in testCase.varValue.vars")
                    custom-point-badge(:value="vars.score")
                      span(class="fieldValue") {{ `${vars.equation}` }}
              
              div(v-if="testCase.graph.isActive")
                el-row.margin-top-5(v-if="testCase.graph.labels.isActive")
                  el-col(:span="6")
                    span(class="fieldLabel") Graph - Labels
                  el-col(:span="18")
                    span(v-if="testCase.graph.labels.title.score")
                      custom-point-badge(:value="testCase.graph.labels.title.score")
                        span(class="fieldValue") {{ `title: "${testCase.graph.labels.title.value}"` }}
                    span(v-if="testCase.graph.labels.xLabel.score")
                      custom-point-badge(:value="testCase.graph.labels.xLabel.score")
                        span(class="fieldValue") {{ `x-axis: "${testCase.graph.labels.xLabel.value}"` }}
                    span(v-if="testCase.graph.labels.yLabel.score")
                      custom-point-badge(:value="testCase.graph.labels.yLabel.score")
                        span(class="fieldValue") {{ `y-axis: "${testCase.graph.labels.yLabel.value}"` }}
                
                el-row.margin-top-5(v-if="testCase.graph.legends.isActive")
                  el-col(:span="6")
                    span(class="fieldLabel") Graph - Legends
                  el-col(:span="18")
                    span(v-for="legend in testCase.graph.legends.legs")
                      custom-point-badge(:value="legend.score")
                        span(class="fieldValue") {{ `${legend.value}` }}

                el-row.margin-top-5(v-if="testCase.graph.limit.isActive")
                  el-col(:span="6")
                    span(class="fieldLabel") Graph - Limit
                  el-col(:span="18")
                    span(v-if="testCase.graph.limit.xLim.score")
                      custom-point-badge(:value="testCase.graph.limit.xLim.score")
                        span(class="fieldValue") {{ `x: ${testCase.graph.limit.xLim.value}` }}
                    span(v-if="testCase.graph.limit.yLim.score")
                      custom-point-badge(:value="testCase.graph.limit.yLim.score")
                        span(class="fieldValue") {{ `y: ${testCase.graph.limit.yLim.value}` }}

                el-row.margin-top-5(v-if="testCase.graph.scale.isActive")
                  el-col(:span="6")
                    span(class="fieldLabel") Graph - Scale
                  el-col(:span="18")
                    span(v-if="testCase.graph.scale.xScale.score")
                      custom-point-badge(:value="testCase.graph.scale.xScale.score")
                        span(class="fieldValue") {{ `x: ${testCase.graph.scale.xScale.value}` }}
                    span(v-if="testCase.graph.scale.yScale.score")
                      custom-point-badge(:value="testCase.graph.scale.yScale.score")
                        span(class="fieldValue") {{ `y: ${testCase.graph.scale.yScale.value}` }}

                el-row.margin-top-5(v-if="testCase.graph.line.isActive")
                  el-col(:span="6")
                    span(class="fieldLabel") Graph - Lines
                  el-col(:span="18")
                    div(v-for="line, lineIdx in testCase.graph.line.lines" :key="lineIdx")
                      el-row.margin-top-5
                        i(class="el-icon-data-line lineIcon")
                        span(class="lineLabel") Line {{ lineIdx + 1 }}
                      el-row
                        span(v-if="line.xData.score")
                          custom-point-badge(:value="line.xData.score")
                            span(class="fieldValue") {{ `x: ${line.xData.value}` }}
                        span(v-if="line.yData.score")
                          custom-point-badge(:value="line.yData.score")
                            span(class="fieldValue") {{ `y: ${line.yData.value}` }}
                        span(v-if="line.style.score")
                          custom-point-badge(:value="line.style.score")
                            span(class="fieldValue") {{ `style: ${line.style.value}` }}
                        span(v-if="line.marker.score")
                          custom-point-badge(:value="line.marker.score")
                            span(class="fieldValue") {{ `marker: ${line.marker.value}` }}
                        span(v-if="line.color.score")
                          custom-point-badge(:value="line.color.score")
                            span(class="fieldValue") {{ `color: ${line.color.value}` }}
            el-row
</template>

<script>
import CustomPointBadge from "@/components/demo/preview/CustomPointBadge";

export default {
  name: "CodingInputPreview",

  components: {
    CustomPointBadge
  },

  props: {
    questionData: {
      type: Object,
      required: true
    },

    contentVisible: {
      type: Boolean,
      required: true
    },

    score: {
      type: Number,
      default: 1
    }
  },

  computed: {}
};
</script>

<style>
.el-collapse {
  background-color: inherit;
  border: none;
}
.el-collapse-item__header {
  background-color: inherit;
  border: none;
}

.el-collapse-item__wrap {
  background-color: inherit;
  border: none;
}

.testLabel {
  font-size: 1em;
  padding-left: 10px;
  color: #424242;
}

.fieldLabel {
  margin-left: 10px;
  font-size: 1em;
  line-height: 2.75em;
  color: var(--darkest-blue);
  font-style: italic;
}

.fieldValue {
  font-size: 1em;
  padding: 8px 15px 8px 15px;
  line-height: 2.5em;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  text-align: center;
  margin-left: 15px;
}

.lineLabel {
  padding: 2px;
  font-size: 1em;
  line-height: 1.5em;
  color: #616161;
}

.lineIcon {
  margin-left: 20px;
  font-size: 1.25em;
  color: #616161;
}

.el-badge {
  margin-right: 10px;
}
</style>
